const fields = [
  'categoryId',
  'playerId',
  'teamId',
  'gameId',
  'gameDate',
  'gameHour',
  'matchDayId',
  'matchLapse',
  'momentOfPlay',
  'startTime',
  'endTime',
  'syncStartFirstTime',
  'syncEndFirstTime',
  'syncStartSecondTime',
  'syncEndSecondTime',
  'syncStartFirstExtraTime',
  'syncEndFirstExtraTime',
  'syncStartSecondExtraTime',
  'syncEndSecondExtraTime',
  'syncStartPenals',
  'syncEndPenals',
  'jersey',
  'x1',
  'y1',
  'x2',
  'y2',
  'x3',
  'y3',
  'rivalTeamId',
  'playId',
  'section',
  'xGoal',
  'yGoal',
  'seasonId',
];
let fieldsObject = null;
let indexObject = null;

export function getPlayContentFields() {
  if (!fieldsObject) {
    fieldsObject = fields.reduce((accumulator, field, index) => {
      accumulator[index] = field;
      return accumulator;
    }, {});
  }
  return fieldsObject;
}

export function getPlayContentIndex() {
  if (!indexObject) {
    indexObject = fields.reduce((accumulator, field, index) => {
      accumulator[field] = index;
      return accumulator;
    }, {});
  }
  return indexObject;
}
